/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  EntityFilter,
  EntityTextFilter,
} from '@backstage/plugin-catalog-react';

export interface CatalogFilters {
  filter: Record<string, string | symbol | (string | symbol)[]>;
  fullTextFilter?: {
    term: string;
  };
}

function isEntityTextFilter(t: EntityFilter): t is EntityTextFilter {
  return !!(t as EntityTextFilter).getFullTextFilters;
}

export function reduceCatalogFilters(filters: EntityFilter[]): CatalogFilters {
  const condensedFilters = filters.reduce<CatalogFilters['filter']>(
    (compoundFilter, filter) => {
      return {
        ...compoundFilter,
        ...(filter.getCatalogFilters ? filter.getCatalogFilters() : {}),
      };
    },
    {},
  );

  const fullTextFilter = filters.find(isEntityTextFilter)?.getFullTextFilters();
  return { filter: condensedFilters, fullTextFilter };
}
